import { UserManager, WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts';

interface OidcConfig {
  authority: string;
  clientId: string;
}

const emptyOidcConfig: OidcConfig = {
  authority: '',
  clientId: ''
};

// Retrieve the OIDC configuration from the backend so per-environment
// values are not hardcoded in the frontend build
let oidcConfig = emptyOidcConfig;
try {
  const response = await fetch('/api/oidc/config');
  if (response.ok) {
    oidcConfig = await response.json();
  }
} catch (error) {
  console.error('OIDC configuration loading failed:', error);
  alert('Failed to load authentication configuration. Unable to authenticate user.');
}

const origin = typeof window !== 'undefined' ? window.location.origin : '';

const settings: UserManagerSettings = {
  authority: oidcConfig.authority,
  client_id: oidcConfig.clientId,
  redirect_uri: `${origin}/oidc-callback`,
  post_logout_redirect_uri: origin,
  response_type: 'code', // Authorization Code + PKCE (PKCE is enabled by default for code flow)
  scope: 'openid profile email offline_access',

  // Renew silently using the offline_access refresh token (no hidden iframe / silent-redirect route needed).
  automaticSilentRenew: true,
  userStore: typeof window !== 'undefined' ? new WebStorageStateStore({ store: window.localStorage }) : undefined
};

export const config = oidcConfig;
export const userManager = new UserManager(settings);
